import * as React from 'react';
import moment from 'moment';

import type { EventElementProps } from './event-element-props.interface';

export const StatusChange = ({ data }: EventElementProps) => (
  <div id={`StatusChange-${data.id}`} className={`owner-box ${data.status}`}>
    <div className="container">
      <div className="content">
        <div className="status">
          <span>
            {data.preview}
          </span>
        </div>
        <div className="chat-timestamp">
          {moment(data.sent_at * 1000).format('L [AT] LT')}
        </div>
      </div>
    </div>
  </div>
);
